import { Inject, Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Observable } from 'rxjs';
import { ApiErrorHandler } from 'tridion.web.ui/src/app/angular/api/error/ApiErrorHandler';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { ENVIRONMENT } from 'tridion.web.ui/src/app/angular/environment/ENVIRONMENT';
import { IEnvironment } from '../../../../environment/IEnvironment';
import { TenaService } from '../../../../product/tena/Tena.service';
import { BaseTCWCatalogApi } from './BaseTCWCatalogApi';
import { ITenaSampleOrder } from '../../../../model/product/tena/tcw/ITenaSampleOrder';
import { LiveStageService } from '../../../../environment/LiveStage.service';
import { TenaSegmentApi } from './../TenaSegmentApi';
import { TenaTCWCatalogApi } from './TenaTCWCatalogApi';
import { ITenaTCWCatalog } from './../../../../model/product/tena/tcw/ITenaTCWCatalog.d';
import { ITenaSegment } from './../../../../model/product/tena/ITenaSegment.d';

@Injectable()
export class TenaSampleOrderApi extends BaseTCWCatalogApi<ITenaSampleOrder> {
    constructor(
        apiErrorHandler: ApiErrorHandler,
        authService: AuthService,
        @Inject(ENVIRONMENT) environment: IEnvironment,
        http: Http,
        tenaService: TenaService,
        readonly tenaService1: TenaService,
        liveStageService: LiveStageService,
        readonly tenaCatalogApi: TenaTCWCatalogApi,
        readonly tenaSegmentsApi: TenaSegmentApi
    ) {
        super(apiErrorHandler, authService, environment, http, tenaService, liveStageService);
    }

    getSampleOrders(
        countryId: number,
        segmentId: number,
        urlFriendlyName: string
    ): Observable<ITenaSampleOrder[]> {
        return this.getJson(`/${countryId}/${segmentId}/${urlFriendlyName}`);
    }

    protected getBaseUrl() {
        this.tenaCatalogApi.getAll().subscribe((res: ITenaTCWCatalog[]) => {
            this.tenaService1.countries.next(res);
        });

        this.tenaSegmentsApi.getAll().subscribe((res: ITenaSegment[]) => {
            const consumerSegments = res.filter(segment => segment.isConsumerSegment);
            this.tenaService1.segments.next(consumerSegments);
        });

        return this.TCWBaseURl + 'ProductSampling';
    }
}
